import { Brand, createBranded } from '@deltasierra/type-utilities';
import { FullAuditable, HasId, IdAndFullAuditableKeys, Omit } from '../../../common';

export type StripeConfigurationId = Brand<number, 'StripeConfigurationId'>;
export const StripeConfigurationId = createBranded<StripeConfigurationId>();

export type StripeScope = 'read_only' | 'read_write';
export type StripeTokenType = 'bearer';

export interface StripeConfiguration extends HasId, FullAuditable {
    stripeUserId: string;
    stripeAccessToken: string;
    stripePublishableKey: string;
    stripeScope: StripeScope;
    stripeLiveMode: boolean;
    stripeTokenType: StripeTokenType;
    stripeRefreshToken: string;
}

export type StripeAccountData = Omit<StripeConfiguration, IdAndFullAuditableKeys>;
